import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import { Box } from "@mui/material";
import { CircularIndeterminate } from "../../../components/common/CircularIndeterminate";
import { useProcessingRequest } from "../../../store/selectors/tableManagementSelector";
import { useServerSidePagination } from "../../../hooks/PaginationHooks";
import { companyBillingsApi } from "../../../api/companyBillingsApi";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import InvoicesTableHeader from "../../superAdminArea/Invoices/InvoicesTableHeader";
import InvoicesTableRow from "../../superAdminArea/Invoices/InvoicesTableRow";


export default function InvoicesPage() {
    const { t } = useTranslation();

    const processingRequest = useProcessingRequest()
    const paginatedData = useServerSidePagination(
        async (paginationParameters) => {
            const res = await companyBillingsApi.getInvoices(paginationParameters);
            return res?.getResultOrNull();
        },
        [],
        "desc",
        "invoiceNumber"
    )

    return (<>
        <PageTitle title={t("invoicesPage.title")} />

        <MainContentWrapper>
            <TableWrapper
                minWidth="1000px"
                columnsTemplate="1fr 1fr 0.5fr"
            >
                <InvoicesTableHeader
                    paginatedData={paginatedData}
                    showCompanyName={false} />

                <Box sx={{ display: "contents" }}>
                    {paginatedData.items.map((item) =>
                        <InvoicesTableRow
                            row={item}
                            showCompanyName={false}
                        />)
                    }
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />
        </MainContentWrapper>

        <CircularIndeterminate processingRequest={processingRequest} />
    </>);
}